import { createContext } from 'react';

interface Fonts {
  body: string;
  button: string;
  heading: string;
}

interface ButtonStyle {
  background: string;
  '&:focus:enabled'?: {
    '&:not(.disabled)'?: {
      background: string;
    };
  };
  '&:hover:enabled'?: {
    '&:not(.disabled)'?: {
      background: string;
    };
  };
}

interface Buttons {
  primary: ButtonStyle;
  primarySmall: ButtonStyle;
  sideSubmitButton: ButtonStyle;
  personalDataEditIcon: {
    background: string;
  };
}

interface Steps {
  stepDone: {
    bg: string;
  };
  done: {
    color: string;
  };
  active: {
    bg: string;
  };
  activeText: {
    color: string;
  };
}

interface Variants {
  buttons: Buttons;
  steps: Steps;
}

interface PartnerTheme {
  fonts: Fonts;
  variants: Variants;
}
interface ConnectionDetails {
  clientId: string;
  clientSecret: string;
  clientName: string;
  comparatorId: string;
}

interface Header {
  title: string;
  text: string;
}

interface PartnerContent {
  steps: {
    header: Header;
  }[];
}

export interface IPartnerContext {
  name: string;
  logo: string;
  ref: string;
  partnerTheme: PartnerTheme | {};
  partnerContent: PartnerContent;
  connectionDetails: ConnectionDetails;
}

export const defaultPartnerContext: IPartnerContext = {
  name: '',
  logo: '',
  ref: '',
  connectionDetails: {
    clientId: '',
    clientSecret: '',
    clientName: '',
    comparatorId: '',
  },
  partnerTheme: {},
  partnerContent: {
    steps: [
      {
        header: {
          title: '',
          text: '',
        },
      },
    ],
  },
};

export const PartnerContext = createContext<IPartnerContext>(
  defaultPartnerContext
);
